// funding interval data will always be atleast 1 hour
export const getFormattedFundingInterval = (fundingInterval?: number) => {
  let formattedFundingInterval = '8h';
  if (!fundingInterval) return formattedFundingInterval;

  const minutes = fundingInterval / 60;
  if (minutes >= 60) {
    const hours = minutes / 60;
    formattedFundingInterval = `${Math.floor(hours)}h`;
  }

  return formattedFundingInterval;
};
